import React, { useState } from 'react';
import { Accordion } from 'react-bootstrap';
import { BsDash, BsPlus } from 'react-icons/bs';
import styled from 'styled-components';

const CustomAccordion = ({ title, content }: TCustomAccordion) => {
  const [isAccordionOpen, setIsAccordionOpen] = useState(false);

  const handleAccordionToggle = () => {
    setIsAccordionOpen(!isAccordionOpen);
  };

  return (
    <StyledAccordion activeKey={isAccordionOpen ? "0" : undefined} onSelect={handleAccordionToggle}>
      <StyledItem eventKey="0">
        <StyledHeader className="accordion-header">
          <span className="accordion-icon">
            {isAccordionOpen ? <BsDash /> : <BsPlus />}
          </span>
          {title}
        </StyledHeader>
        <Accordion.Body>
          <div className="accordion-body">
            {content}
          </div>
        </Accordion.Body>
      </StyledItem>
    </StyledAccordion>
  )
};

type TCustomAccordion = {
  title: string,
  content: string
}

const StyledHeader = styled(Accordion.Header)`
.accordion-button::after{
  display: none !important;
}
`;

const StyledAccordion = styled(Accordion)`
  width: 100%;
    --bs-accordion-border-color: white;
    --bs-accordion-border-width: 0px;
  .accordion-item:first-of-type .accordion-button {
    border-radius: 0 !important;
    box-shadow: none;
    border: none;
    color: black;
    font-size: 18pt;
    margin-bottom: 0px;
    padding-left: 0;
  }
  .accordion-icon {
    margin-right: 5px;
  }
  .accordion-body{
    padding-left: 15px;
    padding-top: 10px;
    padding-bottom: 10px;
  }
`;

const StyledItem = styled(Accordion.Item)`
  .accordion-button:not(.collapsed) {
    background-color: rgba(254, 220, 0, 0.2);
    box-shadow: none;
    border: none;
  }

  font-size: 18pt;
`;

export default CustomAccordion;
